import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface MarqueeSettings {
  desktopSpeed: number;
  mobileSpeed: number;
  fadeSize: number;
  enabled: boolean;
}

export const DEFAULT_MARQUEE_SETTINGS: MarqueeSettings = {
  desktopSpeed: 90,
  mobileSpeed: 60,
  fadeSize: 90,
  enabled: true,
};

export function useMarqueeSettings() {
  const [settings, setSettings] = useState<MarqueeSettings>(DEFAULT_MARQUEE_SETTINGS);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const { data } = await supabase
      .from('site_settings')
      .select('value')
      .eq('key', 'partners_marquee')
      .maybeSingle();
    if (data?.value) {
      setSettings({ ...DEFAULT_MARQUEE_SETTINGS, ...(data.value as Partial<MarqueeSettings>) });
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
    const channel = supabase
      .channel('site_settings_marquee')
      .on('postgres_changes',
        { event: '*', schema: 'public', table: 'site_settings', filter: 'key=eq.partners_marquee' },
        () => load()
      )
      .subscribe();
    return () => { supabase.removeChannel(channel); };
  }, []);

  return { settings, loading };
}
